export const KPI_REGISTRY = [
  // ── Fuel & Consumption ──────────────────────────────────────────────────
  {
    id: "fuel_consumption_rate",
    labelKey: "kpi_fuel_consumption_rate",
    label: "Fuel Consumption Rate - Vehicle",
    domain: "fuel",
    valueFormat: { type: "efficiency", decimals: 2 },
    route: "fuel_consumption_rate",
  },
  {
    id: "fuel_cost",
    labelKey: "kpi_fuel_cost",
    label: "Fuel Cost",
    domain: "fuel",
    valueFormat: { type: "currency", decimals: 2, compact: true },
    route: "fuel_cost",
    // upIsBad: true,
    // severity: (value) => {
    //   if (value > 20000) return 'critical';
    //   if (value > 15000) return 'warning';
    //   return 'healthy';
    // },
  },
  {
    id: "fuel_cost_per_vehicle",
    labelKey: "kpi_fuel_cost_per_vehicle",
    label: "Fuel Cost / Vehicle",
    domain: "fuel",
    valueFormat: { type: "currency", decimals: 2, compact: true },
    route: "fuel_cost_per_vehicle",
  },
  {
    id: "fuel_quantity",
    labelKey: "kpi_fuel_quantity",
    label: "Fuel Consumption - Quantity",
    domain: "fuel",
    valueFormat: { type: "volume", decimals: 2 },
    route: "fuel_quantity",
  },
  // {
  //   id: 'fuel_fillup_count',
  //   label: 'Fill-Up Count',
  //   domain: 'fuel',
  //   valueFormat: { type: 'count' },
  // },

  // ── Vehicle Utilization ─────────────────────────────────────────────────
  {
    id: "avg_vehicle_age",
    labelKey: "kpi_avg_vehicle_age",
    label: "Avg Vehicle Age",
    domain: "utilization",
    valueFormat: { type: "number", decimals: 1, unit: "yrs" },
    route: "avg_vehicle_age",
  },
  {
    id: "vehicle_utilization_rate",
    labelKey: "kpi_vehicle_utilization_rate",
    label: "Utilization Rate / Day - Vehicle",
    domain: "utilization",
    valueFormat: { type: "percent", decimals: 2 },
    route: "vehicle_utilization_rate",
  },
  {
    id: "driver_utilization_rate",
    labelKey: "kpi_driver_utilization_rate",
    label: "Utilization Rate / Day - Driver",
    domain: "utilization",
    valueFormat: { type: "percent", decimals: 2 },
    route: "driver_utilization_rate",
  },
  // {
  //   id: 'vehicles_down',
  //   label: 'Vehicles Down',
  //   domain: 'utilization',
  //   valueFormat: { type: 'percent', decimals: 2 },
  // },

  // {
  //   id: 'avg_odometer',
  //   label: 'Avg Odometer',
  //   domain: 'utilization',
  //   valueFormat: { type: 'odometer' },
  // },

  // ── Total Cost of Ownership ─────────────────────────────────────────────
  {
    id: "lifetime_fleet_tco",
    labelKey: "kpi_lifetime_fleet_tco",
    label: "Lifetime Fleet TCO",
    domain: "tco",
    valueFormat: { type: "currency", decimals: 2, compact: true },
  },
  {
    id: "tco_per_vehicle",
    labelKey: "kpi_tco_per_asset",
    label: "TCO / Vehicle",
    domain: "tco",
    valueFormat: { type: "currency", decimals: 2, compact: true },
  },
  {
    id: "tco_per_mile",
    labelKey: "kpi_tco_per_mile",
    label: "TCO / Mile",
    domain: "tco",
    valueFormat: { type: "currency_per_distance", decimals: 2 },
  },

  // ── Operating Cost ─────────────────────────────────────────────
  {
    id: "operating_cost",
    labelKey: "kpi_operating_cost",
    label: "Operating Cost",
    domain: "oc",
    valueFormat: { type: "currency", decimals: 2, compact: true },
  },
  {
    id: "operating_cost_per_mile",
    labelKey: "kpi_operating_cost_per_mile",
    label: "Operating Cost / Mile",
    domain: "oc",
    valueFormat: { type: "currency_per_distance", decimals: 2 },
  },

  // ── Work Orders ─────────────────────────────────────────────────────────
  {
    id: "percent_vehicles_down",
    labelKey: "kpi_percent_vehicles_down",
    label: "% Vehicles Down",
    domain: "workorders",
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "wo_open_count",
    labelKey: "kpi_wo_open_count",
    label: "Open Work Orders",
    domain: "workorders",
    valueFormat: { type: "count" },
  },
  {
    id: "percent_scheduled_wos",
    labelKey: "kpi_percent_scheduled_wos",
    label: "% Scheduled WOs",
    domain: "workorders",
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "avg_cost_per_wo",
    labelKey: "kpi_avg_cost_per_wo",
    label: "Avg WO Cost",
    domain: "workorders",
    valueFormat: { type: "currency", decimals: 2, compact: true },
  },

  // ── Inspections & Downtime ───────────────────────────────────────────
  {
    id: "percent_vehicles_inspected",
    labelKey: "kpi_percent_vehicles_inspected",
    label: "% Vehicles Inspected",
    domain: "inspections",
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "cumulative_downtime_hours",
    labelKey: "kpi_cumulative_downtime_hours",
    label: "Cumulative Downtime Hours",
    domain: "inspections",
    valueFormat: { type: "number", decimals: 1, unit: "hrs" },
  },
];

export const KPI_MAP = Object.fromEntries(KPI_REGISTRY.map((k) => [k.id, k]));

export const DEFAULT_KPI_IDS = [
  "fuel_consumption_rate",
  "fuel_cost_per_vehicle",
  "operating_cost",
  "percent_vehicles_inspected",
];
